module.exports = __webpack_public_path__ + "static/clients_gallery_booking@2x-de28f00f46bc6c6797547ac43bc6fc31.png";